var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbInstaCombinedCardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.196,
    cy: 0.967,
    r: 1.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fb741e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#de286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a030b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#436def"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(-304 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram_2",
    "data-name": "Instagram 2",
    transform: "translate(324 166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M110.174,122.466c-1.565-.011-2.8-.011-4.039-.032-.687,0-1.361-.046-2.041-.092a8.143,8.143,0,0,1-2.71-.635,6.335,6.335,0,0,1-3.492-3.636,8.247,8.247,0,0,1-.483-1.989c-.057-.474-.087-.948-.1-1.425-.023-.916-.05-1.833-.057-2.763v-4.062c0-.589,0-1.18.021-1.766s.037-1.146.071-1.7a8.637,8.637,0,0,1,.669-2.978,6.319,6.319,0,0,1,3.46-3.393,8.088,8.088,0,0,1,2.445-.58c1.1-.1,2.216-.121,3.324-.121h5.973c.788,0,1.579.044,2.364.1a8.081,8.081,0,0,1,2.724.632,6.326,6.326,0,0,1,3.5,3.666,8.367,8.367,0,0,1,.493,2.11c.06.532.076,1.063.1,1.6.046,1.058.044,2.115.044,3.173v4.3c0,.788-.039,1.576-.076,2.364a9.37,9.37,0,0,1-.408,2.376,6.527,6.527,0,0,1-1.146,2.19,6.433,6.433,0,0,1-2.9,2.062,8.284,8.284,0,0,1-2.131.458c-.6.048-1.214.085-1.821.1C112.589,122.446,111.219,122.455,110.174,122.466Zm-10.651-12.6v1.178c0,1.146,0,2.275.048,3.414.021.472.037.944.1,1.411a5.928,5.928,0,0,0,.435,1.62,4.064,4.064,0,0,0,1.927,2.03,5.54,5.54,0,0,0,2.062.552c.534.046,1.07.073,1.6.089.722.023,1.443.032,2.163.032q2.71,0,5.421-.016c.768,0,1.537-.03,2.291-.1a6.223,6.223,0,0,0,1.693-.385,4.092,4.092,0,0,0,2.232-2.044,5.6,5.6,0,0,0,.538-2.08c.046-.566.073-1.134.089-1.7.021-.724.027-1.45.03-2.174v-4.025c0-.664-.016-1.331-.034-2-.014-.559-.032-1.12-.1-1.677a6.028,6.028,0,0,0-.408-1.638A4.067,4.067,0,0,0,117.6,100.2a5.478,5.478,0,0,0-2.009-.529c-.591-.05-1.182-.08-1.776-.1-.765-.023-1.53-.03-2.291-.027-2.252,0-4.5-.039-6.754.069a9.005,9.005,0,0,0-1.583.195,4.713,4.713,0,0,0-1.5.593,4.165,4.165,0,0,0-1.746,2.222,7.13,7.13,0,0,0-.351,1.92c-.037.687-.064,1.375-.071,2.076,0,1.072,0,3.235,0,3.235Z",
    transform: "translate(-89.842 -89.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M130.89,137.775a6.925,6.925,0,1,1,4.9-2.026A6.927,6.927,0,0,1,130.89,137.775Zm-4.484-6.942a4.5,4.5,0,1,0,1.331-3.176A4.5,4.5,0,0,0,126.406,130.833Z",
    transform: "translate(-110.898 -110.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M176.6,116.21a1.619,1.619,0,1,1-1.631,1.594A1.619,1.619,0,0,1,176.6,116.21Z",
    transform: "translate(-149.719 -104.703)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4376",
    "data-name": "Group 4376",
    transform: "translate(304 166)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 20,
    cy: 19.83,
    rx: 20,
    ry: 19.83,
    transform: "translate(0 0.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FB",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M39.855,20.122A19.928,19.928,0,1,0,0,20.122,20.069,20.069,0,0,0,16.814,40V25.939h-5.06V20.122h5.06V15.689c0-5.043,2.975-7.829,7.526-7.829a30.058,30.058,0,0,1,4.461.4v4.951H26.288a2.894,2.894,0,0,0-3.247,3.143v3.775h5.526l-.883,5.817H23.039V40A20.069,20.069,0,0,0,39.855,20.122Z",
    transform: "translate(0 0)",
    fill: "#1877f2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbInstaCombinedCardIcon);
export default __webpack_public_path__ + "static/media/fb-insta-combined-card-icon.ce57b321f017ecf776f329fff112dadb.svg";
export { ForwardRef as ReactComponent };